"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateAllFieldsCommand = void 0;
var tslib_1 = require("tslib");
var tree_creator_1 = require("../../../core/model/fields/tree-creator");
var control_1 = require("../../../core/model/options/control");
var sub_document_1 = require("../../../core/model/sub-document");
var number_1 = require("@devexpress/utils/lib/utils/map/number");
var command_states_1 = require("../command-states");
var update_field_command_base_1 = require("./update-field-command-base");
var UpdateAllFieldsCommand = (function (_super) {
    tslib_1.__extends(UpdateAllFieldsCommand, _super);
    function UpdateAllFieldsCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UpdateAllFieldsCommand.prototype.getState = function () {
        return new command_states_1.SimpleCommandState(this.isEnabled());
    };
    UpdateAllFieldsCommand.prototype.isEnabled = function () {
        return _super.prototype.isEnabled.call(this) && control_1.ControlOptions.isEnabled(this.control.modelManager.richOptions.control.fields);
    };
    UpdateAllFieldsCommand.prototype.executeCore = function (_state, options) {
        var _this = this;
        var subDocsInfo = number_1.NumberMapUtils.toListBy(this.modelManipulator.model.subDocuments, function (sd) { return new sub_document_1.SubDocumentIntervals(sd, [sd.interval]); });
        var floatingState = this.selection.getFloatingState();
        return update_field_command_base_1.UpdateFieldCommandBase.updateFields(this, subDocsInfo, function () {
            var selState = floatingState.finalize();
            _this.selection.setState(selState);
            if (options.param)
                options.param();
        }, new tree_creator_1.UpdateFieldsOptions());
    };
    return UpdateAllFieldsCommand;
}(update_field_command_base_1.UpdateFieldCommandBase));
exports.UpdateAllFieldsCommand = UpdateAllFieldsCommand;
